(function () {

  const FORM_HOST = "product-form-component";

  function parseOptionCounts(host) {
    try {
      return JSON.parse(host.dataset.bzOptionCounts || "[]");
    } catch {
      return [];
    }
  }

  function getRequiredOptionGroups(host) {

  const optionCounts = parseOptionCounts(host);

  const required = [];

  optionCounts.forEach((count, i) => {
    if (Number(count) > 1) {
      required.push({
        index: i + 1,
        count: count
      });
    }
  });

  return required;

}

  function hasInlineUI(host) {
    return host.dataset.bzInlineOptionUi === "true";
  }

  function findMissingSelections(host) {

    const required = getRequiredOptionGroups(host);
    if (!required.length) return [];

    const form = host.querySelector("form");
    if (!form) return [];

    const optionGroups = form.querySelectorAll(".bz-option-group");
    const missing = [];

    required.forEach(requiredOpt => {

      const group = Array.from(optionGroups).find(g =>
        String(g.dataset.optionPosition) === String(requiredOpt.index)
      );

      if (!group) return;

      // IMPORTANT: require explicit user interaction
      const userSelected = group.dataset.userSelected === "true";

      if (!userSelected) {
        missing.push(group);
      }

    });

    return missing;
  }

  function showError(host) {

    const liveRegion =
      host.querySelector('[ref="liveRegion"]') ||
      host.querySelector('[aria-live]');

    if (liveRegion) {
      liveRegion.textContent =
        "Please select your options before adding to cart.";
    }

  }

  function redirectToProduct(host) {

    const url = host.dataset.bzProductUrl;

    if (url) {
      window.location.href = url;
    }

  }

  document.addEventListener(
    "submit",
    function (e) {

      const form = e.target;
      const host = form.closest(FORM_HOST);

      if (!host) return;

      if (host.dataset.bzSelectionPolicy !== "strict") return;

      const requiredGroups = getRequiredOptionGroups(host);

      // If no option has more than one variant, allow submission
      if (!requiredGroups.length) return;

      const missing = findMissingSelections(host);

      if (!missing.length) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (hasInlineUI(host)) {

        showError(host);

        const first = missing[0];

        first.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });

      } else {

        redirectToProduct(host);

      }

    },
    true
  );

})();